<template lang="pug">
  div.intervention
    h3  {{ intervention[0]['TBL_Interventi.intervento'] }}
    table
      thead
        tr
          th Azione
          th Tipologia
          th Fase
          th
      tbody
        slot
</template>

<script>
export default {
  name: 'InterventionList',
  props: {
    intervention: Array
  },
  data () {
    return {
      filters: ''
    }
  },
  created: function () {
    // console.log('intervention:', this.intervention)
  },
  methods: {
    placeHolder (e) {
      // console.log('fire', e)
    }
  }
}
</script>

<style lang='scss' scoped>
.intervention {
  margin-top: 3em;
  margin-bottom: 3em;
}
table {
  widows: 100%;
}
h3,
.content table thead th {
  color: $link;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/InterventionList.vue